export const initExpoMatching = (form = {}) => ({
    ...(form || {}),

    _program: form?._program || null,

    _employee: form?._employee || null,
    _employeeUser: form?._employeeUser || null,

    _employer: form?._employer || null,
    _employerUser: form?._employerUser || null,

    direction: form?.direction || null,
    interviewAt: form?.interviewAt || null,

    isGranted: form?.isGranted ?? null,
    grantedAt: form?.grantedAt || null,

    refuseMsg: form?.refuseMsg || null,
    refusedAt: form?.refusedAt || null,

    isSuccess: form?.isSuccess ?? null,
    employMsg: form?.employMsg || null,
});
